import { F01_MEMOJI_PURPLE_IMAGES } from 'data/images/f01/memoji-purple'
import type { VariantImagesDefinition } from 'types/images'

import { WALLPIF01_IMAGES } from './default'

export const WALLPIF01_MEMOJI_PURPLE_IMAGES = {
  ...F01_MEMOJI_PURPLE_IMAGES,
  experience: {
    background: {
      ...WALLPIF01_IMAGES.experience.background,
      srcSet: [
        '/images/wallpif01/memoji-purple/experience.webp',
        '/images/wallpif01/memoji-purple/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...WALLPIF01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/wallpif01/memoji-purple/experience_pitch.webp',
        '/images/wallpif01/memoji-purple/experience_pitch@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      ...WALLPIF01_IMAGES.bigResultsPitch.first,
      srcSet: [
        '/images/wallpif01/memoji-purple/big-results-pitch/big_results_pitch_01.webp',
        '/images/wallpif01/memoji-purple/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      ...WALLPIF01_IMAGES.bigResultsPitch.second,
      srcSet: [
        '/images/wallpif01/memoji-purple/big-results-pitch/big_results_pitch_02.webp',
        '/images/wallpif01/memoji-purple/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      ...WALLPIF01_IMAGES.bigResultsPitch.third,
      srcSet: [
        '/images/wallpif01/memoji-purple/big-results-pitch/big_results_pitch_03.webp',
        '/images/wallpif01/memoji-purple/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
    mockup: WALLPIF01_IMAGES.bigResultsPitch.mockup,
  },
  problemAreasPitch: {
    mockup: WALLPIF01_IMAGES.problemAreasPitch.mockup,
  },
} satisfies VariantImagesDefinition<typeof WALLPIF01_IMAGES>
